<h1 mat-dialog-title class="{{'mat-dialog-title ' + data.type}}">{{data.title}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.text"></p>
  <br>
  <a [href]="data.link" *ngIf="data.link">{{data.link}}</a>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" mat-button (click)="closeDialog()">Ok</button>
</div>
